import { Heading, List, Stack, Text } from '@chakra-ui/react';

export const TCDE = () => {
  return (
    <div>
      <Heading as="h1" size="md" mt={4}>
        ALLGEMEINE GESCHÄFTSBEDINGUNGEN
      </Heading>
      <Text fontWeight="bold" mt={2}>
        SUP SUP CLUB B.V.
      </Text>
      <Text fontStyle="italic">(Version Februar 2026)</Text>
      <Stack gap={4} mt={4}>
        <Heading size="md">Artikel 1 – Definitionen</Heading>
        <Text fontWeight="bold">Sup Sup Club</Text>
        <Text>
          Sup Sup Club B.V., eine Gesellschaft mit beschränkter Haftung nach
          niederländischem Recht, mit Sitz in Amsterdam und Geschäftsadresse
          Herengracht 406, 1017 BX Amsterdam, eingetragen im niederländischen
          Handelsregister unter der Nummer 81205309.
        </Text>
        <Text fontWeight="bold">Website</Text>
        <Text>
          www.supsupclub.com oder jede andere vom Sup Sup Club festgelegte
          Website.
        </Text>
        <Text fontWeight="bold">App</Text>
        <Text>
          Die digitale Umgebung, die über app2.supsupclub.com oder jede andere
          vom Sup Sup Club festgelegte URL zugänglich ist, über die
          Reservierungen vorgenommen und Schließfächer geöffnet werden.
        </Text>
        <Text fontWeight="bold">Kundenservice</Text>
        <Text>
          Erreichbar unter der Telefonnummer +31 85 130 9686, per E-Mail an
          info@supsupclub.com oder über die in der App aufgeführten
          Kontaktmöglichkeiten.
        </Text>
        <Text fontWeight="bold">Station</Text>
        <Text>
          Eine automatisierte, unbemannte Verleihstation, in der sich
          SUP-Boards, Zubehör und Schließfächer befinden.
        </Text>
        <Text fontWeight="bold">Schließfach</Text>
        <Text>
          Die abschließbaren Fächer innerhalb der Station, die über die App
          zugänglich sind.
        </Text>
        <Text fontWeight="bold">Self-Service-Verleih</Text>
        <Text>
          Der automatisierte Verleih von SUP-Boards ohne physische Präsenz,
          Aufsicht, Anweisung oder Anleitung durch Personal.
        </Text>
        <Text fontWeight="bold">Teilnehmer</Text>
        <Text>
          Jede natürliche Person, die ein über den Sup Sup Club reserviertes
          SUP-Board oder Schließfach nutzt.
        </Text>
        <Text fontWeight="bold">Buchender Teilnehmer</Text>
        <Text>
          Die natürliche Person, die über die App ein oder mehrere SUP-Boards
          reserviert.
        </Text>
        <Text fontWeight="bold">Vertrag</Text>
        <Text>
          Der Vertrag zwischen dem Sup Sup Club und dem Teilnehmer über die
          vorübergehende Nutzung eines SUP-Boards, Schließfachs und der Station.
        </Text>

        <Heading size="md">
          Artikel 2 – Vertragspartei &amp; Self-Service-Modell
        </Heading>
        <List.Root>
          <List.Item>
            Der Vertrag kommt ausschließlich zwischen dem Teilnehmer und Sup Sup
            Club B.V. zustande.
          </List.Item>
          <List.Item>
            Etwaige Franchisenehmer, Standortanbieter oder andere beteiligte
            Parteien sind keine Vertragsparteien dieses Vertrags.
          </List.Item>
          <List.Item>
            Der Sup Sup Club ist der Anbieter von automatisiertem
            Self-Service-Wassersportverleih.
          </List.Item>
          <List.Item>
            Grundsätzlich ist kein Mitarbeiter des Sup Sup Club,
            Franchisenehmers oder Standortanbieters physisch an der Station
            anwesend.
          </List.Item>
          <List.Item>
            Es gibt keine Aufsicht, keine Einweisung und keinen Rettungsdienst
            vor Ort.
          </List.Item>
          <List.Item>
            Der Teilnehmer erkennt ausdrücklich an, dass die Nutzung der
            gemieteten Ausrüstung eigenständig und ohne Anleitung erfolgt.
          </List.Item>
        </List.Root>

        <Heading size="md">
          Artikel 3 – Zustandekommen des Vertrags &amp; Gruppenbuchungen
        </Heading>
        <Text>Der Vertrag kommt zustande, wenn:</Text>
        <List.Root>
          <List.Item>
            eine Reservierung über die App vorgenommen wird;
          </List.Item>
          <List.Item>
            diese Allgemeinen Geschäftsbedingungen akzeptiert werden;
          </List.Item>
          <List.Item>und die Zahlung abgeschlossen ist.</List.Item>
        </List.Root>
        <Text>
          Der Vertrag endet automatisch mit Ablauf der reservierten Mietdauer.
        </Text>
        <Text>Wenn der buchende Teilnehmer mehrere SUP-Boards reserviert:</Text>
        <List.Root>
          <List.Item>
            erklärt er/sie, bevollmächtigt zu sein, den Vertrag im Namen aller
            Mitnutzer abzuschließen;
          </List.Item>
          <List.Item>
            erklärt er/sie, dass alle Mitnutzer diese Allgemeinen
            Geschäftsbedingungen zur Kenntnis genommen haben und ihnen
            zustimmen;
          </List.Item>
          <List.Item>
            garantiert er/sie, dass alle Mitnutzer die Teilnahmevoraussetzungen
            erfüllen.
          </List.Item>
        </List.Root>
        <Text>
          Der buchende Teilnehmer haftet gesamtschuldnerisch für Schäden, die
          durch die von ihm/ihr angemeldeten Mitnutzer verursacht werden.
        </Text>
        <Text>
          Jeder Mitnutzer gilt im Sinne dieser Allgemeinen Geschäftsbedingungen
          einzeln als Teilnehmer.
        </Text>

        <Heading size="md">Artikel 4 – Teilnahmevoraussetzungen</Heading>
        <Text>
          Das Mindestalter für den selbstständigen Verleih beträgt 18 Jahre.
        </Text>
        <Text>Der Teilnehmer erklärt:</Text>
        <List.Root>
          <List.Item>
            mindestens das niederländische Schwimmdiplom A zu besitzen oder über
            eine gleichwertige Grundschwimmfähigkeit zu verfügen, die ausreicht,
            um selbstständig im offenen Wasser zu schwimmen und sich in
            Sicherheit zu bringen;
          </List.Item>
          <List.Item>
            körperlich in der Lage zu sein, Stand-Up-Paddling auszuüben;
          </List.Item>
          <List.Item>
            nicht unter dem Einfluss von Alkohol, Drogen oder ähnlichen
            Substanzen zu stehen.
          </List.Item>
        </List.Root>
        <Text>
          Minderjährige dürfen die Ausrüstung nur unter direkter Aufsicht eines
          Erwachsenen (18+) nutzen, der ebenfalls mindestens das niederländische
          Schwimmdiplom A oder eine gleichwertige Grundschwimmfähigkeit besitzt.
        </Text>
        <Text>
          Der Sup Sup Club stellt während des Self-Service-Verleihs keine
          Schwimmwesten zur Verfügung.
        </Text>
        <Text>
          Der Teilnehmer erkennt an, dass das Fehlen von Schwimmwesten Teil des
          Self-Service-Charakters des Verleihs ist und dass er/sie diesbezüglich
          die volle Verantwortung trägt.
        </Text>
        <Text>
          Der Sup Sup Club behält sich das Recht vor, die Teilnahme ohne Angabe
          von Gründen zu verweigern.
        </Text>

        <Heading size="md">Artikel 5 – Übernahme von Risiken</Heading>
        <Text>
          Der Teilnehmer erkennt an, dass Wassersport, einschließlich
          Stand-Up-Paddling, inhärente Risiken birgt, einschließlich, aber nicht
          beschränkt auf:
        </Text>
        <List.Root>
          <List.Item>Ertrinken;</List.Item>
          <List.Item>Unterkühlung;</List.Item>
          <List.Item>Strömungen;</List.Item>
          <List.Item>Kollisionen;</List.Item>
          <List.Item>plötzliche Wetteränderungen;</List.Item>
          <List.Item>Körperverletzungen.</List.Item>
        </List.Root>
        <Text>Der Teilnehmer erkennt ausdrücklich an, dass:</Text>
        <List.Root>
          <List.Item>keine physische Aufsicht vorhanden ist;</List.Item>
          <List.Item>keine Rettungsdienste verfügbar sind;</List.Item>
          <List.Item>keine Schwimmwesten bereitgestellt werden;</List.Item>
          <List.Item>
            er/sie allein verantwortlich für die Beurteilung der
            Wetterbedingungen, Wasserbedingungen und der persönlichen Sicherheit
            ist.
          </List.Item>
        </List.Root>
        <Text>
          Die Nutzung der Ausrüstung erfolgt vollständig auf eigenes Risiko des
          Teilnehmers.
        </Text>

        <Heading size="md">
          Artikel 6 – Ausrüstung, Schließfach &amp; Sorgfältige Nutzung
        </Heading>
        <List.Root>
          <List.Item>
            Der Teilnehmer muss das SUP-Board, das Zubehör, das Schließfach und
            die Station vor der Nutzung auf sichtbare Mängel überprüfen.
          </List.Item>
          <List.Item>
            Der Teilnehmer muss das SUP-Board, das Schließfach und die Station
            sorgfältig und in Übereinstimmung mit den in der App und an der
            Station bereitgestellten Anweisungen nutzen.
          </List.Item>
          <List.Item>
            Das Öffnen und Schließen des Schließfachs erfolgt vollständig auf
            eigenes Risiko des Teilnehmers.
          </List.Item>
          <List.Item>
            Die Nutzung des Schließfachs erfolgt vollständig auf eigenes Risiko
            des Teilnehmers.
          </List.Item>
          <List.Item>
            Der Sup Sup Club übernimmt keine Aufbewahrungspflicht (Verwahrung)
            bezüglich der in das Schließfach gelegten persönlichen Gegenstände.
          </List.Item>
          <List.Item>
            Der Sup Sup Club haftet nicht für Verlust, Diebstahl oder
            Beschädigung von Gegenständen, die im oder am Schließfach
            zurückgelassen werden.
          </List.Item>
          <List.Item>
            Dem Teilnehmer wird ausdrücklich geraten, keine wertvollen
            Gegenstände im Schließfach zu hinterlassen.
          </List.Item>
        </List.Root>
        <Text>Im Zweifelsfall oder bei Mängeln:</Text>
        <List.Root>
          <List.Item>
            darf die Ausrüstung oder das Schließfach nicht genutzt werden;
          </List.Item>
          <List.Item>
            muss der Sup Sup Club umgehend über die App oder den Kundenservice
            kontaktiert werden.
          </List.Item>
        </List.Root>
        <Text>
          Der Sup Sup Club ist berechtigt, ein Schließfach oder eine Station
          sofort zu deaktivieren, wenn die Sicherheit dies erfordert.
        </Text>

        <Heading size="md">
          Artikel 7 – Preise, Änderung &amp; Stornierung
        </Heading>
        <Text>
          Die Zahlung muss im Voraus über das digitale System erfolgen.
        </Text>
        <Text>
          Der Teilnehmer kann die Reservierung bis zu vier (4) Stunden vor
          Beginn des reservierten Zeitraums ausschließlich über die App und nach
          Verfügbarkeit auf ein anderes verfügbares Zeitfenster umbuchen.
        </Text>
        <Text>
          Eine Änderung der Reservierung berechtigt den Teilnehmer nicht zu
          einer Rückerstattung.
        </Text>
        <Text>
          Eine Stornierung durch den Teilnehmer berechtigt den Teilnehmer nicht
          zu einer Rückerstattung.
        </Text>
        <Text>
          Der Sup Sup Club kann eine Reservierung stornieren oder aussetzen bei:
        </Text>
        <List.Root>
          <List.Item>extremen Wetterbedingungen;</List.Item>
          <List.Item>Sicherheitsrisiken;</List.Item>
          <List.Item>behördlichen Einschränkungen;</List.Item>
          <List.Item>technischen Störungen.</List.Item>
        </List.Root>
        <Text>
          In einem solchen Fall wird der Sup Sup Club dem Teilnehmer zunächst
          die Möglichkeit anbieten, die Reservierung kostenlos zu verschieben.
        </Text>
        <Text>
          Wenn eine Verschiebung nicht möglich ist oder vom Teilnehmer nicht
          akzeptiert wird, wird der gezahlte Betrag zurückerstattet.
        </Text>
        <Text>
          Gemäß Artikel 6:230p Buchstabe e des niederländischen Bürgerlichen
          Gesetzbuchs gilt das gesetzliche Widerrufsrecht nicht, da es sich bei
          dem Vertrag um eine Freizeitaktivität mit einem bestimmten Datum oder
          Zeitraum für die Erfüllung handelt.
        </Text>

        <Heading size="md">Artikel 8 – Haftung</Heading>
        <Text>
          Der Sup Sup Club haftet nur bei Vorsatz oder grober Fahrlässigkeit
          seiner gesetzlichen Vertreter.
        </Text>
        <Text>
          Jegliche Haftung ist auf den unter der anwendbaren Versicherungspolice
          ausgezahlten Betrag beschränkt.
        </Text>
        <Text>Der Sup Sup Club haftet nicht für:</Text>
        <List.Root>
          <List.Item>Ertrinken;</List.Item>
          <List.Item>Körperverletzungen;</List.Item>
          <List.Item>Folgeschäden;</List.Item>
          <List.Item>
            Verlust oder Diebstahl persönlicher Gegenstände;
          </List.Item>
          <List.Item>Schäden infolge von Wetterbedingungen;</List.Item>
          <List.Item>
            Verletzungen, die sich aus der Nutzung der Station oder des
            Schließfachs ergeben, es sei denn, sie wurden durch Vorsatz oder
            grobe Fahrlässigkeit verursacht.
          </List.Item>
        </List.Root>
        <Text>
          Die Nutzung des SUP-Boards, Schließfachs und der Station erfolgt
          vollständig auf eigenes Risiko des Teilnehmers.
        </Text>
        <Text>
          Diese Haftungsbeschränkungen gelten auch zugunsten von
          Franchisenehmern, Standortanbietern, Mitarbeitern und
          Erfüllungsgehilfen, die vom Sup Sup Club eingesetzt werden.
        </Text>
        <Text>
          Der Teilnehmer stellt den Sup Sup Club von Ansprüchen Dritter frei,
          die sich aus seiner Nutzung des SUP-Boards, Schließfachs oder der
          Station ergeben.
        </Text>

        <Heading size="md">Artikel 9 – Schäden</Heading>
        <Text>Der Teilnehmer haftet für Schäden an:</Text>
        <List.Root>
          <List.Item>dem SUP-Board;</List.Item>
          <List.Item>Zubehör;</List.Item>
          <List.Item>dem Schließfach;</List.Item>
          <List.Item>der Station;</List.Item>
        </List.Root>
        <Text>
          wenn solche Schäden auf Fahrlässigkeit, unsachgemäßen Gebrauch oder
          vorsätzliches Verhalten zurückzuführen sind.
        </Text>

        <Heading size="md">Artikel 10 – Höhere Gewalt</Heading>
        <Text>
          Der Sup Sup Club haftet nicht für Ausfälle infolge höherer Gewalt,
          einschließlich, aber nicht beschränkt auf extreme Wetterbedingungen,
          Naturkatastrophen, behördliche Maßnahmen oder technische
          Systemausfälle.
        </Text>

        <Heading size="md">Artikel 11 – Personenbezogene Daten</Heading>
        <Text>
          Personenbezogene Daten werden in Übereinstimmung mit der
          Datenschutz-Grundverordnung (DSGVO) und der Datenschutzerklärung des
          Sup Sup Club verarbeitet.
        </Text>

        <Heading size="md">Artikel 12 – Anwendbares Recht</Heading>
        <List.Root>
          <List.Item>
            Alle Rechtsbeziehungen mit dem Sup Sup Club unterliegen
            ausschließlich niederländischem Recht.
          </List.Item>
          <List.Item>
            Alle Streitigkeiten werden ausschließlich dem zuständigen Gericht in
            Amsterdam vorgelegt.
          </List.Item>
          <List.Item>
            Bei Widersprüchen zwischen der niederländischen und der englischen
            Version dieser Allgemeinen Geschäftsbedingungen hat die
            niederländische Version Vorrang.
          </List.Item>
        </List.Root>
      </Stack>
    </div>
  );
};
